// React Dependencies
import React, { useEffect, useState } from 'react';
// External Dependencies
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, Divider, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Internal Dependencies
import Colours from '../../../../styles/colours';
import MText from '../../../../components/Common/MText';
import MButton from '../../../../components/MButton';
import MTextField from '../../../../components/MTextField';
import ApiService from '../../../../services/apiService';
import Loading from '../../../../components/Loading';
import Icons from '../../../../components/Common/Icons';
import { IsEmpty } from '../../../../common/checks';
import { Trim } from '../../../../common/util';

const CreateEditAlbumModal = (props) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.open) {
      if (!IsEmpty(props.album)) {
        setName(props.album.name || '');
        setDescription(props.album.description || '');
      } else {
        setName('');
        setDescription('');
      }
    }
  }, [props.open, props.album]);

  const onSave = async () => {
    if (IsEmpty(Trim(name))) {
      toast.error('Album name is required');
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        name:        Trim(name),
        description: Trim(description),
      };

      let album;
      if (!IsEmpty(props.album)) {
        album = await ApiService.updatePageAlbum(props.page.id, props.album.id, payload);
        toast.success('Album updated successfully');
      } else {
        album = await ApiService.createPageAlbum(props.page.id, payload);
        toast.success('Album created successfully');
      }

      props.onComplete(album);
      props.onClose();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm" scroll="body">
      {isLoading && <Loading zIndex={9999} />}
      <DialogTitle>
        <div className="w-100 d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center">
            <MText text={!IsEmpty(props.album) ? 'Edit Album' : 'Create Album'} size={15} />
            <IconButton onClick={props.onClose} size="small">
              <Icons.Cross color={Colours.Black} fontSize={20} />
            </IconButton>
          </div>
          <Divider className="mt-2" />
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column pb-4">
          <div className="d-flex">
            <MText text="Album Name" size={12} className="mb-1" />
            <MText text="*" colour={Colours.Red} style={{ marginLeft: '0.1rem' }} />
          </div>

          <MTextField
            value={name}
            onChange={(val) => setName(val)}
            placeholder="Enter album name"
            className="mb-4"
          />

          <MText text="Description" size={12} className="mb-1" />
          <MTextField
            value={description}
            onChange={(val) => setDescription(val)}
            placeholder="Enter album description"
            minRows={3}
            maxRows={5}
            className="mb-1"
          />

          <MText text="* required" italic colour={Colours.Red} medium className="mb-3" />
        </div>
        <Divider className="mb-3" />
        <div className="d-flex justify-content-between pb-3">
          <MButton text="Cancel" variant="outlined" onClick={props.onClose} />
          <MButton text="Save" colour={Colours.Secondary} textColour={Colours.White} onClick={onSave} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

CreateEditAlbumModal.propTypes = {
  open:       PropTypes.bool.isRequired,
  onClose:    PropTypes.func.isRequired,
  album:      PropTypes.shape(Object),
  page:       PropTypes.shape(Object).isRequired,
  onComplete: PropTypes.func.isRequired,
};

CreateEditAlbumModal.defaultProps = {
  album: {},
};

const mapStateToProps = (state) => ({
  page: state.page.selected,
});

export default connect(mapStateToProps, null)(CreateEditAlbumModal);
